<template>
  <v-menu offset-y bottom left :z-index="20">
    <template #activator="{ on }">
      <v-btn
        icon
        small
        class="account-menu__btn"
        v-auto-tooltip="user && user.name ? user.name : 'Tu cuenta'"
        v-on="on"
      >
        <v-icon small>mdi-account-circle</v-icon>
      </v-btn>
    </template>

    <v-list dense class="account-menu">
      <v-list-item v-if="user" class="account-menu__header">
        <v-list-item-content>
          <v-list-item-title class="account-menu__name">{{ user.name }}</v-list-item-title>
          <v-list-item-subtitle class="account-menu__detail">
            <!-- Por defecto el correo; el portal de incidentes pone en su lugar
                 las corporaciones que acotan lo que el operador ve. -->
            <slot name="detail">{{ user.email }}</slot>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="user" />
      <v-list-item @click="logout">
        <v-list-item-icon class="mr-2"><v-icon small>mdi-logout</v-icon></v-list-item-icon>
        <v-list-item-title>Cerrar sesión</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'

// Menú de cuenta: única implementación del proyecto. La usan AppSectionHeader
// —y por tanto las cinco vistas de pantalla completa— y MapToolbar.
//
// Antes solo existía en el portal de incidentes y en los dos mapas, así que la
// consola de medidas cautelares, el simulador y los dos monitores de analíticos
// se quedaban sin forma de cerrar sesión: son rutas sin layout, o sea sin
// drawer, de modo que no había ningún otro sitio donde hacerlo.
export default {
  name: 'AccountMenu',
  computed: {
    ...mapGetters('auth', ['getUser']),
    user() { return this.getUser },
  },
  methods: {
    async logout() {
      try {
        await this.$confirm({
          title: 'Cerrar sesión',
          description: '¿Está seguro de que desea cerrar la sesión?',
          acceptText: 'Sí, cerrar sesión',
          cancelText: 'Cancelar',
        })
      } catch (e) {
        return // cancelado
      }
      // La mutación SET_LOGOUT hace el trabajo completo: DELETE /session,
      // borra la cookie JSESSIONID, limpia presets y redirige a /auth/login.
      // Por eso aquí no hay router.push: sería redundante.
      this.$store.dispatch('auth/logout')
    },
  },
}
</script>

<style scoped>
/* Un solo aspecto para las seis secciones. Hubo un intento de prop `btnClass`
   para que el mapa conservara el suyo, pero habría sido inerte: sus clases
   viven en un <style scoped> que no alcanza a un botón renderizado desde aquí. */
.account-menu__btn {
  color: var(--kln-text-dim) !important;
  background: transparent !important;
  border-radius: 6px !important;
  transition: color 0.2s, background-color 0.2s;
}

.account-menu__btn:hover {
  color: var(--kln-text-muted) !important;
  background: var(--kln-border-dim) !important;
}

.account-menu {
  background: var(--kln-bg-overlay) !important;
  border: 1px solid var(--kln-border-normal);
  border-radius: 8px;
  min-width: 220px;
  padding: 4px 0;
}

/* La fila de identidad es informativa: no debe capturar el clic. */
.account-menu__header {
  pointer-events: none;
  padding: 8px 14px 4px;
}

.account-menu__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--kln-text);
}

.account-menu__detail {
  font-size: 11px !important;
  color: var(--kln-text-dim) !important;
}
</style>
